import React, { ReactElement } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const DragAndDropProvider: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    children,
  } = props;

  return (
    <DndProvider backend={HTML5Backend}>
      {children}
    </DndProvider>
  );
});

export default DragAndDropProvider;
